import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { Avatar, Box, Button, DataTable, useCommonComponentContext } from "@maysoft/common-component-react";

import useChannel from "./useChannel";
import ChannelEditContainer from "./edit";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import ChannelService from "../../services/message/Channel.service";

import { Mode } from "../../constants/enums";
import { Constants } from "../../constants/constants";
import { IRecordChannel, IRequestGetpaged } from "./useChannel";

const ChannelListContainer = (props: { communityId: string; isCreateUpdate?: boolean; request?: IRequestGetpaged }) => {
    const Strings = useStrings();

    const { onError, onHideLoading, onShowLoading } = useCommonComponentContext();

    const { handleDeleteChannel } = useChannel();

    const [titlePopup, setTitlePopup] = useState<string>("");
    const [openPopup, setOpenPopup] = useState<boolean>(false);
    const [modePopup, setModePopup] = useState<Mode>(Mode.Create);
    const [itemRow, setItemRow] = useState<IRecordChannel | undefined>(undefined);

    const [dataRows, setDataRows] = useState<IRecordChannel[]>([]);
    const [model, setModel] = useState<IRequestGetpaged>({} as IRequestGetpaged);

    useEffect(() => {
        if (Helpers.isNullOrEmpty(props.communityId)) {
            return;
        } else {
            const req: IRequestGetpaged = {
                pageSize: props.request?.pageSize,
                pageNumber: props.request?.pageNumber,
                searchText: props.request?.searchText,
                totalCount: props.request?.totalCount,
            };
            getPaged(req);
        }
    }, [props.request, props.communityId]);

    const getPaged = async (dataReq?: IRequestGetpaged) => {
        try {
            onShowLoading();

            const pageSize = dataReq?.pageSize || Constants.ROW_PER_PAGE;
            const pageNumber = Helpers.getPageNumber(dataReq?.pageNumber || 1, pageSize, dataReq?.totalCount || 0);

            const result = await ChannelService.getPaged({
                communityId: props.communityId,
                pageSize: pageSize,
                pageNumber: pageNumber,
                searchText: dataReq?.searchText,
            });

            setDataRows([...(result?.items || [])]);

            setModel({
                pageSize: result?.pageSize,
                pageNumber: result?.currentPage,
                searchText: dataReq?.searchText,
                totalCount: result?.totalCount,
            });

            onHideLoading();
        } catch (error) {
            onHideLoading();
            const err = Helpers.renderExceptionError(error);
            onError(err);
        }
    };

    return Helpers.isNullOrEmpty(props.communityId) ? (
        <></>
    ) : (
        <Box m={2}>
            {props.isCreateUpdate && (
                <>
                    <Box alignItems="center" justifyContent="flex-end" display="flex" mb={3}>
                        <Button
                            onClick={() => {
                                setTitlePopup(Strings.CHANNEL.TITLE_CREATE_VIEW);
                                setModePopup(Mode.Create);
                                setOpenPopup(true);
                            }}
                        >
                            <Add />
                            &nbsp;{Strings.Common.ADD_NEW}
                        </Button>
                    </Box>
                    <ChannelEditContainer
                        communityId={props.communityId}
                        id={itemRow?.id}
                        mode={modePopup}
                        title={titlePopup}
                        onCallBack={() => {
                            getPaged({ ...model });
                        }}
                        onChangeMode={(value) => {
                            setModePopup(value);
                        }}
                        dataPopup={{
                            isShowPopup: true,
                            openPopup: openPopup,
                            onClosePopup() {
                                setTitlePopup("");
                                setOpenPopup(false);
                                setItemRow(undefined);
                                setModePopup(Mode.Create);
                            },
                        }}
                    />
                </>
            )}

            <DataTable
                isLocal
                isShowIndex
                rowPerPage={model?.pageSize}
                pageNumber={model?.pageNumber}
                totalCount={model?.totalCount}
                onChangePageSize={(pageSize) => {
                    getPaged({ ...model, pageSize });
                }}
                onChangePageNumber={(pageNumber) => {
                    getPaged({ ...model, pageNumber });
                }}
                table={{
                    rows: dataRows || [],
                    columns: [
                        {
                            Header: Strings.CHANNEL.IMAGE,
                            accessor: "avatarImageUrl",
                            width: "80",
                            Cell: (row) => (
                                <Avatar
                                    src={row?.value}
                                    text={row?.row?.original?.name || ""}
                                    alt="avatarImageUrl"
                                    sx={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: 2,
                                        objectFit: "cover",
                                    }}
                                />
                            ),
                        },
                        {
                            Header: Strings.CHANNEL.CHANNEL_NAME,
                            accessor: "name",
                            width: "200",
                        },
                        {
                            Header: Strings.CHANNEL.TOTAL_MEMBER,
                            accessor: "totalMember",
                            width: "auto",
                        },
                        {
                            Header: Strings.CHANNEL.TOTAL_POST,
                            accessor: "totalPost",
                            width: "auto",
                        },
                    ],
                }}
                actionList={[
                    {
                        key: "view",
                        iconName: "view",
                        title: Strings.Common.VIEW_DETAIL,
                        callback: (row) => {
                            setTitlePopup(Strings.CHANNEL.TITLE_DETAIL_VIEW);
                            setModePopup(Mode.View);
                            setOpenPopup(true);
                            setItemRow(row);
                        },
                    },
                    {
                        key: "edit",
                        iconName: "edit",
                        title: Strings.Common.EDIT,
                        callback: (row) => {
                            setTitlePopup(Strings.CHANNEL.TITLE_UPDATE_VIEW);
                            setModePopup(Mode.Update);
                            setOpenPopup(true);
                            setItemRow(row);
                        },
                    },
                    {
                        key: "delete",
                        iconName: "delete",
                        title: Strings.Common.DELETE,
                        callback: (row) => {
                            handleDeleteChannel({
                                channelId: row?.id,
                                onCallBack() {
                                    getPaged({ ...model });
                                },
                            });
                        },
                    },
                ]}
            />
        </Box>
    );
};

export default ChannelListContainer;
